import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { requestInterface } from 'src/app/util/interfaces/request';
import { environment } from 'src/environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { catchError, map } from 'rxjs/operators';
import { logInterface } from 'src/app/util/interfaces/log.interface';
import { groupHistoryInterface } from 'src/app/util/interfaces/groupHistory';
import { tasksInterface } from 'src/app/util/interfaces/tasks';
import { changePlanInterface } from 'src/app/util/interfaces/changePlan';
import { relatedCisInterface } from 'src/app/util/interfaces/relatedCis';
import { classificationInterface } from 'src/app/util/interfaces/classification';
import { scopeInterface } from 'src/app/util/interfaces/scope';
import { groupInterface } from 'src/app/util/interfaces/group';
import { topicsInterface } from 'src/app/util/interfaces/topics';
import { categoryInterface } from 'src/app/util/interfaces/category';
import { reportOptionsInterface } from 'src/app/util/interfaces/reportOptions';
import { relatedArticlesInterface } from 'src/app/util/interfaces/relatedArticles';
import { ciInterface } from 'src/app/util/interfaces/ci';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';
import { FilesService } from 'src/app/services/files/files.service';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { serviceTypeInterface } from 'src/app/util/interfaces/requestClassification';
import { subRequestInterface } from 'src/app/util/interfaces/subRequest';
import { statusInterface } from 'src/app/util/interfaces/statusInterface';
import { mimeTypeInterface } from 'src/app/util/interfaces/mimeTypeInterface';
import { emailStatusInterface } from 'src/app/util/interfaces/emailCustom';
import { CreateRequestResponse } from 'src/app/util/interfaces/createRequestResponse';
import { RequestUpdatePayload } from 'src/app/util/interfaces/requestUpdatePayload';
import { TaskCustomField } from 'src/app/util/interfaces/request/taskCustomField';

@Injectable({
	providedIn: 'root',
})
export class RequestPageService {
	private getRequestUrl = environment.baseApiUrl + 'request/{idRequest}';
	private putRequestInfoUrl = environment.baseApiUrl + 'request/{idRequest}';
	private getAllStatusUrl = environment.baseApiUrl + 'request/status';
	private getAvailableStatusUrl = environment.baseApiUrl + 'request/{idRequest}/status';
	private getAvailableAnalystsUrl = environment.baseApiUrl + 'solutionarea/request/{idRequest}?analyst_active=true';
	private getAvailableAnalystsSolutionAreaUrl = environment.baseApiUrl + 'solutionarea/solutionarea/{idSolutionArea}';
	private addLogUrl = environment.baseApiUrl + 'request/{idRequest}/log';
	private getLogUrl = environment.baseApiUrl + 'request/{idRequest}/log';
	private superUpdateLogUrl = environment.baseApiUrl + 'super/update/log/{idLog}';
	private classificationUrl = environment.baseApiUrl + 'request/classification/customer/{customerId}/servicetype/{serviceTypeId}';
	private groupClassificationUrl =
		environment.baseApiUrl + 'request/classification/customer/{customerId}/servicetype/{serviceTypeId}/topic/{topicId}';
	private getCustomfieldUrl = environment.baseApiUrl + 'request/{idRequest}/customField';
	private getCiTypesUrl = environment.baseApiUrl + 'cmdb/citype';
	private reportOptionsUrl: string = environment.baseApiUrl + 'request/search/filter';
	private searchCisUrl = environment.baseApiUrl + 'cmdb/search?&{queryString}';
	private postInsertCiRequest = environment.baseApiUrl + 'request/{idRequest}/relatedCIs';
	private deleteCiRequest = environment.baseApiUrl + 'request/{idRequest}/relatedCIs/{idCi}';
	private putRequestClassify = environment.baseApiUrl + 'request/{idRequest}';
	private getCustomfieldSearchUrl = environment.baseApiUrl + 'request/customField/search/{idTopic}/{idCategory}/{idSolutionArea}';
	private cloneRequestUrl = environment.baseApiUrl + 'request';
	private putTaskUrl = environment.baseApiUrl + 'request/{idRequest}/task';
	private putTaskApproverUrl = environment.baseApiUrl + 'request/task/approver/{idRequest}';
	private putChangePlanUrl = environment.baseApiUrl + 'request/{idRequest}/changePlan';
	private postLogFileAttach2 = environment.baseApiUrl + 'request/{idLog}/upload';
	private getLogFile = environment.baseApiUrl + 'request/fileAttach/{fileName}';
	private getAvailableUsersUrl = environment.baseApiUrl + 'request/relatedEnduser';
	private putCountStrikeUrl = environment.baseApiUrl + 'request/putCountStrike/{idRequest}';
	private getCheckSlaTaskUrl = environment.baseApiUrl + 'subrequest/checkSlaTask';
	private postRequestFromTask = environment.baseApiUrl + 'subrequest/requestfromtask';
	private postEmailSendUserUrl = environment.baseApiUrl + 'request/{idLog}/logEmail';
	private checkEmailStatusURL = environment.baseApiUrl + 'request/checkEmailStatus';
	private searchKbSolutionURL = environment.baseApiUrl + 'knowSolutions';
	private closeChildRequestsUrl = environment.baseApiUrl + 'request/closeChild/{idRequest}';
	private postCustomTasksUrl = environment.baseApiUrl + 'request/customTask';
	private deleteCustomTaskUrl = environment.baseApiUrl + 'request/customTask/{idTask}';
	private getCrisisTeamFormUrl = environment.baseApiUrl + 'request/crisisTeam/form/{idRequest}';
	private crisisTeamUrl = environment.baseApiUrl + 'request/crisisTeam/{idRequest}';
	private getTaskCustomFieldUrl = environment.baseApiUrl + 'request/taskCustomField';
	private updateTaskCustomFieldUrl = environment.baseApiUrl + 'request/taskCustomField';
	private getAvailableConfidentialUsersUrl = environment.baseApiUrl + 'request/confidentialUser/available';
	private getConfidentialUsersUrl = environment.baseApiUrl + 'request/confidentialUser/{idRequest}';
	private getChangePlanUrl = environment.baseApiUrl + 'request/{idRequest}/changePlanDates';
	private putUpdateChangePlanDates = environment.baseApiUrl + 'request/{idRequest}/changePlanDates';
	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getRequest(idRequest: string): Observable<requestInterface> {
		const getRequestUrl = this.getRequestUrl.replace('{idRequest}', idRequest);
		return this.http.get<JSON[]>(getRequestUrl, { headers: this.headers }).pipe(
			map((requestRes: any) => {
				requestRes = requestRes[0];
				const newRequest: requestInterface = {
					id: requestRes.id,
					registered_by: requestRes.registered_by,
					first_classified_by: requestRes.first_classified_by,
					open_date: requestRes.open_date,
					limit_date: requestRes.limit_date,
					close_date: requestRes.close_date,
					duration: requestRes.duration,
					sla_remaining: requestRes.sla_remaining,
					id_customer: requestRes.idCustomer,
					id_enduser: requestRes.idenduser,
					enduser: requestRes.enduser,
					email_enduser: requestRes.email_enduser,
					phone_enduser: requestRes.phone_enduser,
					analyst: requestRes.analyst,
					id_analyst: requestRes.idAnalyst,
					email_analyst: requestRes.email_analyst,
					contacts_analyst: requestRes.contacts_analyst,
					site: requestRes.site,
					location: requestRes.location,
					affected_location: requestRes.affected_location,
					department: requestRes.department,
					idRelatedEnduser: requestRes.idrelatedenduser,
					relatedEnduser: requestRes.relatedenduser,
					summary: requestRes.summary,
					// "description" : this.replaceNewlinesAndBr(requestRes.detail),
					description: requestRes.detail,
					notes: requestRes.notes,
					id_solution_area: requestRes.idSolution_area,
					solution_area: requestRes.solution_area,
					id_service_type: requestRes.id_service_type,
					service_type: requestRes.service_type,
					status: requestRes.status,
					scope: requestRes.scope,
					id_scope: requestRes.idScope,
					category: requestRes.category,
					id_category: requestRes.idCategory,
					topic: requestRes.topic,
					id_topic: requestRes.idTopic,
					impact: requestRes.impact,
					urgency: requestRes.urgency,
					riskType: requestRes.urgent_change,
					change_type: requestRes.change_type,
					severity: requestRes.severity,
					high_severity: requestRes.high_severity,
					id_severity: requestRes.idSeverity,
					file_attach: requestRes.file_attach,
					active: requestRes.active,
					risk_assessement: requestRes.risk_assessement,
					fallback: requestRes.fallback,
					customer: requestRes.customer,
					business_hours: requestRes.business_hours,
					count_strikes: requestRes.count_strikes,
					last_strike: requestRes.last_strike,
					classification_date: requestRes.classification_date,
					parent_request: { id: '', status: '' },
					child_requests: [],
					logs: [],
					history: [],
					tasks: [],
					changePlan: [],
					relatedArticles: [],
					attached_files: [],
					mandatoryCiBinding: requestRes.mandatoryCiBinding,
					relatedCis: requestRes.related_cis,
					relatedInconsistency: requestRes.related_inconsistency,
					allowedCiTypes: requestRes.allowedCiTypes,
					confidential: requestRes.confidential,
					contract_manager: requestRes.contract_manager,
					idlocation: requestRes.idlocation,
					idAffectedLocation: requestRes.id_affected_location,
				};

				if (requestRes.parent_request) {
					const newRelatedRequest: requestInterface = { id: requestRes.parent_request, status: '' };
					newRequest.parent_request = newRelatedRequest;
				}

				if (requestRes.related_requests && requestRes.related_requests.length > 0) {
					for (const child_request of requestRes.related_requests) {
						const newRelatedRequest: requestInterface = { id: child_request.id, summary: child_request.summary, status: '' };
						newRequest.child_requests.push(newRelatedRequest);
					}
				}

				if (requestRes.request_log && requestRes.request_log.length > 0 && requestRes.request_log[0].idLog !== '0') {
					requestRes.request_log.forEach((log: any) => {
						const newFileLogArray: mspFileInterface[] = [];
						for (const file of log.file_log) {
							const newFileLog: mspFileInterface = {
								file_path: '',
								checkSum: '',
								content: '',
								extension: '',
								mimeType: '',
								name: '',
								size: 0,
							};
							newFileLog.file_path = file;
							newFileLogArray.push(newFileLog);
						}

						const newLog: logInterface = {
							idLog: log.idLog,
							log_date: log.log_date,
							analyst: log.analyst,
							notes: log.notes,
							// "notes" : this.replaceNewlinesAndBr(log.notes),
							status: log.status,
							file_log: newFileLogArray,
							duration: log.duration,
						};
						newRequest.logs.push(newLog);
					});
				}

				if (
					requestRes.solution_area_history &&
					requestRes.solution_area_history.length > 0 &&
					requestRes.solution_area_history[0].idSolutionAreaHistory !== '0'
				) {
					requestRes.solution_area_history.forEach((solutionArea: any) => {
						const newSolutionArea: groupHistoryInterface = {
							id: solutionArea.idSolutionAreaHistory,
							service: solutionArea.service,
							group: solutionArea.solution_area,
							start: solutionArea.start_date,
							end: solutionArea.end_date,
							sla: solutionArea.sla,
							spent: solutionArea.sla_spent,
							analyst: solutionArea.analyst,
							scope: solutionArea.scope,
							category: solutionArea.category,
							topic: solutionArea.topic,
							serviceType: solutionArea.service_type,
							severity: solutionArea.severity,
							businessHours: solutionArea.business_hours,
							slaViolation: solutionArea.sla_violation,
							urgency: solutionArea.urgency,
							riskImpact: solutionArea.risk_impact,
						};
						newRequest.history.push(newSolutionArea);
					});
				}

				if (requestRes.request_tasks && requestRes.request_tasks.length > 0 && requestRes.request_tasks[0].id_task !== '0') {
					requestRes.request_tasks.forEach((task: any) => {
						const newFiletaskArray: mspFileInterface[] = [];
						for (const file of task.task_file) {
							const newFileTask: mspFileInterface = {
								file_path: '',
								checkSum: '',
								content: '',
								extension: '',
								mimeType: '',
								name: '',
								size: 0,
							};
							newFileTask.file_path = file;
							newFiletaskArray.push(newFileTask);
						}

						const newTask: tasksInterface = {
							id_task: task.id_task,
							task_order_number: task.task_id,
							task_name: task.task_name,
							predecessor: task.predecessor,
							show_buttons: task.showButtons ? true : false,
							// "task_description": this.replaceNewlinesAndBr(task.taskDescription),
							task_description: task.taskDescription,
							task_status: task.task_status,
							finished: task.finished,
							task_available_status: task.task_status_options,
							task_type: task.task_type,
							task_analyst: task.task_analyst,
							task_id_solution_area: task.task_id_solution_area,
							available_task_approver: task.available_task_approvers,
							already_approved_analysts: task.already_approved_analysts,
							selected_task_approver: task.selected_task_approver,
							available_task_analysts: task.available_task_analysts,
							approvedList: [],
							remainingApproveList: [],
							connector: task.connector,
							taskApproverFormItem: undefined,
							attachment: newFiletaskArray,
							subrequest_id: task.subrequest_id,
							limit_date: task.limit_date,
							upload_required: task.upload_required,
							custom_task: task.custom_task,
							disableApproverControls: task.disableApproverControls,
						};

						const taskApproverFormItem: genericFormInterface[] = [
							{
								name: 'taskApprover',
								label: 'lbl_grupo_aprovadores',
								inputType: 'multi-select',
								required: true,
								items: [],
								values: [],
								rawValues: [],
								outItems: [],
								filterItem: [],
								filterOutItem: [],
								filterValues: [],
							},
							{
								name: 'taskConnector',
								label: 'lbl_regra_aprovacao',
								inputType: 'select',
								required: true,
								hideUndefined: true,
								items: [
									{
										name: 'OR',
										label: 'lbl_apenas_aprovacao',
										values: ['OU'],
									},
									{
										name: 'all',
										label: 'lbl_todos_devem_aprovar',
										values: ['E'],
									},
								],
								values: [task.connector],
							},
						];

						for (const task_approver of task.available_task_approvers) {
							const newItem: genericFormInterface = {
								name: task_approver.email,
								label: task_approver.full_name,
								values: [task_approver.email],
							};

							taskApproverFormItem[0].items.push(newItem);
						}

						for (const task_approver of task.selected_task_approver) {
							const newItem: genericFormInterface = {
								name: task_approver.email,
								label: task_approver.full_name,
								values: [task_approver.email],
							};

							taskApproverFormItem[0].items.push(newItem);
							taskApproverFormItem[0].values.push(newItem);
							taskApproverFormItem[0].rawValues.push(newItem.values[0]);

							if (task_approver.approved_date && task_approver.approved_date != '')
								newTask.approvedList.push(task_approver.full_name);
							else newTask.remainingApproveList.push(task_approver.full_name);
						}

						newTask.taskApproverFormItem = taskApproverFormItem;

						newRequest.tasks.push(newTask);
					});
				}

				if (requestRes.change_plan && requestRes.change_plan.length > 0 && requestRes.change_plan[0].risk_assessement !== '') {
					requestRes.change_plan.forEach((change: any) => {
						const newChange: changePlanInterface = {
							urgency: Number.parseInt(change.riskUrgency),
							impact: Number.parseInt(change.riskImpact),
							category: Number.parseInt(change.riskCategory),
							risk: Number.parseInt(change.risk),
							fileAttach: change.fileAttachChangePlan,
							riskAssessement: change.riskAssessement.replaceAll('<br>', '\n'),
							fallback: change.fallback.replaceAll('<br>', '\n'),
							priority: 0,
						};

						newRequest.changePlan.push(newChange);
					});
				}

				if (requestRes.related_articles && requestRes.related_articles.length > 0 && requestRes.related_articles[0].id !== '0') {
					requestRes.related_articles.forEach((rArticle: any) => {
						const newArticle: relatedArticlesInterface = {
							id: rArticle.id,
							summary: rArticle.summary,
						};
						newRequest.relatedArticles.push(newArticle);
					});
				}

				if (requestRes.attached_files && requestRes.attached_files.length > 0) {
					requestRes.attached_files.forEach((attachedFiles: any) => {
						if (attachedFiles.idAttachedFile != '') {
							const newAttachedFile: requestInterface['attached_files'][number] = {
								idAttachedFile: attachedFiles.idAttachedFile,
								typeAttachedFile: attachedFiles.typeAttachedFile,
								attachedFile: attachedFiles.attachedFile,
							};

							newRequest.attached_files.push(newAttachedFile);
						}
					});
					newRequest.attached_files.reverse();
				}

				return newRequest;
			})
		);
	}

	updateRequestData(data: RequestUpdatePayload): Observable<RequestUpdatePayload> {
		const putRequestInfoUrl = this.putRequestInfoUrl.replace('{idRequest}', data.idRequest);

		return this.http.put<RequestUpdatePayload>(putRequestInfoUrl, data, { headers: this.headers });
	}

	getAnalystList(idRequest: string): Observable<enduserInterface[]> {
		const getAvailableAnalystsUrl = this.getAvailableAnalystsUrl.replace('{idRequest}', idRequest);
		return this.http.get<any[]>(getAvailableAnalystsUrl, { headers: this.headers }).pipe(
			map((analystListRes) => {
				const newAnalystArray: enduserInterface[] = [];

				for (const analyst of analystListRes) {
					const newAnalyst: enduserInterface = {
						fullName: analyst.fullName,
						email: analyst.email,
						id: analyst.id,
					};

					newAnalystArray.push(newAnalyst);
				}

				return newAnalystArray;
			})
		);
	}

	getAnalystListBySolutionArea(idSolutionArea: string): Observable<enduserInterface[]> {
		const getAvailableAnalystsSolutionAreaUrl = this.getAvailableAnalystsSolutionAreaUrl.replace('{idSolutionArea}', idSolutionArea);
		return this.http.get<any[]>(getAvailableAnalystsSolutionAreaUrl, { headers: this.headers }).pipe(
			map((analystListRes) => {
				const newAnalystArray: enduserInterface[] = [];

				for (const analyst of analystListRes) {
					const newAnalyst: enduserInterface = {
						fullName: analyst.fullName,
						email: analyst.email,
						id: analyst.id,
					};

					newAnalystArray.push(newAnalyst);
				}

				return newAnalystArray;
			})
		);
	}

	getAllStatus(): Observable<statusInterface[]> {
		return this.http.get<statusInterface[]>(this.getAllStatusUrl, { headers: this.headers });
	}

	getAvailableStatus(idRequest: string): Observable<statusInterface[]> {
		const getAvailableStatusUrl = this.getAvailableStatusUrl.replace('{idRequest}', idRequest);
		return this.http.get<JSON>(getAvailableStatusUrl, { headers: this.headers }).pipe(
			map((statusRes: any) => {
				const newAvailableStatus: statusInterface[] = [];

				for (const status of statusRes) {
					const newStatus: statusInterface = {
						status: status.status,
						label: status.label,
					};
					newAvailableStatus.push(newStatus);
				}

				return newAvailableStatus;
			})
		);
	}

	addLog(requestId: string, log: logInterface): Observable<any> {
		const body = {
			logNotes: log.notes,
			status: log.status,
			duration: log.duration,
			overdueReason: log.overdueReason,
			emailCC: log.email_cc,
			sendEmailAttachEnduser: log.sendEmailAttachEnduser === true ? 1 : 0,
		};
		const addLogUrl = this.addLogUrl.replace('{idRequest}', requestId);
		return this.http.post<JSON>(addLogUrl, body, { headers: this.headers });
	}

	getLog(requestId: string): Observable<logInterface[]> {
		const getLogUrl = this.getLogUrl.replace('{idRequest}', requestId);
		return this.http.get<JSON>(getLogUrl, { headers: this.headers }).pipe(
			map((logs: any) => {
				const newLogArray: logInterface[] = [];
				for (const log of logs) {
					const newFileLogArray: mspFileInterface[] = [];
					for (const file of log.file_log) {
						const newFileLog: mspFileInterface = {
							file_path: '',
							checkSum: '',
							content: '',
							extension: '',
							mimeType: '',
							name: '',
							size: 0,
						};

						newFileLog.file_path = file;
						newFileLogArray.push(newFileLog);
					}

					const newLog: logInterface = {
						idLog: log.idLog,
						log_date: log.log_date,
						analyst: log.analyst,
						// "notes" : this.htmlDecode(log.notes),
						notes: log.notes,
						status: log.status,
						file_log: newFileLogArray,
						duration: log.duration,
					};

					newLogArray.push(newLog);
				}

				return newLogArray;
			})
		);
	}

	sendAttach(idLog: string, mspFile: mspFileInterface[]): Observable<mspFileInterface[]> {
		const postLogFileAttach = this.postLogFileAttach2.replace('{idLog}', idLog);
		return this.http.post(postLogFileAttach, mspFile, { headers: this.headers }).pipe(
			map((filePostRes: any) => {
				const newMspFileArray: mspFileInterface[] = [];
				for (const file of filePostRes) {
					const newMspFile: mspFileInterface = {
						content: '',
						name: '',
						mimeType: '',
						extension: '',
						size: 0,
						file_path: file.filePath,
					};
					newMspFileArray.push(newMspFile);
				}

				return newMspFileArray;
			})
		);
	}

	getAvailableEmailCCUsers(): Observable<enduserInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get<JSON[]>(this.getAvailableUsersUrl, { headers: headers }).pipe(
			map((endusersRes: any) => {
				const newEnduserArray: enduserInterface[] = [];

				endusersRes.forEach((enduser: any) => {
					const newEnduser: enduserInterface = {
						id: enduser.id,
						fullName: enduser.full_name,
						email: enduser.email,
					};

					newEnduserArray.push(newEnduser);
				});

				newEnduserArray.sort((a, b) => {
					if (a.fullName > b.fullName) return 1;
					if (a.fullName < b.fullName) return -1;
					return 0;
				});
				return newEnduserArray;
			})
		);
	}

	superUpdateLog(superNewLog: logInterface): Observable<JSON> {
		const body = {
			analyst: superNewLog.analyst,
			duration: superNewLog.duration,
			notes: superNewLog.notes,
			status: superNewLog.status,
			log_date: superNewLog.log_date,
		};
		const superUpdateLogUrl = this.superUpdateLogUrl.replace('{idLog}', superNewLog.idLog);
		return this.http.put<JSON>(superUpdateLogUrl, body, { headers: this.headers });
	}

	// getClassificationServiceType(): Observable<serviceTypeInterface[]> {
	//   let mockServiceType : serviceTypeInterface[] = [
	//     {"id":"1", "label":"Problem", "name":"Problem"},
	//     {"id":"2", "label":"Incident", "name":"Incident"},
	//     {"id":"3", "label":"Change", "name":"Change"},
	//     {"id":"5", "label":"Complaint", "name":"Complaint"},
	//     {"id":"6", "label":"Service Request", "name":"Service Request"},
	//   ]

	//   return of(mockServiceType);
	// }

	getGeneralClassification(serviceTypeId: string, customerId: string): Observable<classificationInterface> {
		let classificationUrl = this.classificationUrl.replace('{serviceTypeId}', serviceTypeId);
		classificationUrl = classificationUrl.replace('{customerId}', customerId);
		return this.http.get<JSON>(classificationUrl, { headers: this.headers }).pipe(
			map((allCustomerClassification: any) => {
				const newClassification: classificationInterface = {
					serviceType: [],
					scope: [],
					category: [],
					topic: [],
					solutionArea: [],
				};

				const newScopeArray: scopeInterface[] = [];
				if (allCustomerClassification.scopes && allCustomerClassification.scopes.length > 0) {
					allCustomerClassification.scopes.forEach((scope: any) => {
						const newScope: scopeInterface = { id: scope.id, scope_name: scope.text };
						newScopeArray.push(newScope);
					});
				}
				newClassification.scope = newScopeArray;

				const newCategoryArray: categoryInterface[] = [];
				if (allCustomerClassification.categories && allCustomerClassification.categories.length > 0) {
					allCustomerClassification.categories.forEach((category: any) => {
						const newCategory: categoryInterface = { id: category.id, category_name: category.text, scope_id: category.scope };
						newCategoryArray.push(newCategory);
					});
				}
				newClassification.category = newCategoryArray;

				const newTopicArray: topicsInterface[] = [];
				if (allCustomerClassification.topics && allCustomerClassification.topics.length > 0) {
					allCustomerClassification.topics.forEach((topic: any) => {
						const newTopic: topicsInterface = {
							id: topic.id,
							topic_name: topic.text,
							category_id: topic.category,
							severity: topic.severity,
						};
						newTopicArray.push(newTopic);
					});
				}
				newClassification.topic = newTopicArray;

				return newClassification;
			})
		);
	}

	getGroupsClassification(topicId: string, serviceTypeId: string, customerId: string): Observable<groupInterface[]> {
		let groupClassificationUrl = this.groupClassificationUrl.replace('{serviceTypeId}', serviceTypeId);
		groupClassificationUrl = groupClassificationUrl.replace('{customerId}', customerId);
		groupClassificationUrl = groupClassificationUrl.replace('{topicId}', topicId);
		return this.http.get<JSON>(groupClassificationUrl, { headers: this.headers }).pipe(
			map((groupJson: any) => {
				const newGroupArray: groupInterface[] = [];
				if (groupJson.solution_areas && groupJson.solution_areas.length > 0) {
					for (const group of groupJson.solution_areas) {
						const newGroup: groupInterface = {
							id: group.id,
							group_name: group.text,
							topic_id: topicId,
						};
						newGroupArray.push(newGroup);
					}
				}

				return newGroupArray;
			})
		);
	}

	putCustomfields(requestCustomField: genericFormInterface[], idRequest: string): Observable<any> {
		if (requestCustomField.length === 0) return of({});

		const putCustomfieldUrl = this.getCustomfieldUrl.replace('{idRequest}', idRequest);
		const body: any = { requestFields: [] };
		for (const customfield of requestCustomField) {
			if (customfield.inputType == 'multi-select' || customfield.inputType == 'checkbox') {
				const customfieldPost = {
					fieldId: customfield.id,
					fieldValue: customfield.rawValues.join('§'),
					fieldType: customfield.inputType,
				};
				body.requestFields.push(customfieldPost);
			} else {
				const isJsonDynamic = customfield.rawInputType === 'json_dynamic';
				const customfieldPost: any = {
					fieldId: customfield.id,
					// json_dynamic: rawValues[0] é o JSON do objeto selecionado
					fieldValue: isJsonDynamic ? (customfield.rawValues?.[0] ?? '') : customfield.values[0],
					fieldType: customfield.rawInputType ?? customfield.inputType,
				};
				if (isJsonDynamic) {
					customfieldPost.fieldJson = customfield.rawJsonValue ?? '';
				}
				body.requestFields.push(customfieldPost);
			}
		}

		return this.http.put<JSON>(putCustomfieldUrl, body, { headers: this.headers });
	}

	postCustomfields(requestCustomField: genericFormInterface[], idRequest: string): Observable<any> {
		if (requestCustomField.length === 0) return of({});

		const postCustomfieldUrl = this.getCustomfieldUrl.replace('{idRequest}', idRequest);
		const body: any = { requestFields: [] };
		for (const customfield of requestCustomField) {
			if (customfield.inputType == 'multi-select' || customfield.inputType == 'checkbox') {
				const customfieldPost = {
					fieldId: customfield.id,
					fieldValue: customfield.rawValues.join('§'),
					fieldType: customfield.inputType,
				};
				body.requestFields.push(customfieldPost);
			} else {
				const isJsonDynamic = customfield.rawInputType === 'json_dynamic';
				const customfieldPost: any = {
					fieldId: customfield.id,
					// json_dynamic: rawValues[0] é o JSON do objeto selecionado
					fieldValue: isJsonDynamic ? (customfield.rawValues?.[0] ?? '') : customfield.values[0],
					fieldType: customfield.rawInputType ?? customfield.inputType,
				};
				if (isJsonDynamic) {
					customfieldPost.fieldJson = customfield.rawJsonValue ?? '';
				}
				body.requestFields.push(customfieldPost);
			}
		}
		return this.http.post<JSON>(postCustomfieldUrl, body, { headers: this.headers });
	}

	deleteCustomfields(requestCustomField: genericFormInterface[], idRequest: string): Observable<any> {
		if (requestCustomField.length === 0) return of({});

		const deleteCustomfieldUrl = this.getCustomfieldUrl.replace('{idRequest}', idRequest);
		const body: any = { requestFields: [] };
		for (const customfield of requestCustomField) {
			if (customfield.inputType == 'multi-select' || customfield.inputType == 'checkbox') {
				const customfieldPost = {
					fieldId: customfield.id,
					fieldValue: customfield.rawValues.join('§'),
					fieldType: customfield.inputType,
				};
				body.requestFields.push(customfieldPost);
			} else {
				const customfieldPost = {
					fieldId: customfield.id,
					fieldValue: customfield.values[0],
					fieldType: customfield.inputType,
				};
				body.requestFields.push(customfieldPost);
			}
		}

		return this.http.request<JSON>('delete', deleteCustomfieldUrl, { headers: this.headers, body: body });
	}

	getTaskCustomFields(filters: object): Observable<any> {
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<any>(this.getTaskCustomFieldUrl, { headers: this.headers, params: parameters });
	}

	updateTaskCustomFields(fields: TaskCustomField[]): Observable<any> {
		if (fields.length === 0) {
			return of({ message: 'Nenhum campo para atualizar' });
		}

		return this.http.put<any>(this.updateTaskCustomFieldUrl, fields, { headers: this.headers }).pipe(
			catchError((error) => {
				console.error('Erro ao atualizar os campos personalizados:', error);
				return throwError(() => new Error('Falha ao atualizar campos personalizados.'));
			})
		);
	}

	htmlDecode(input: any) {
		const document = new DOMParser().parseFromString(input, 'text/html');
		return document.documentElement.textContent;
	}

	getSolutionArea(): Observable<reportOptionsInterface[]> {
		return this.http.get<JSON[]>(this.reportOptionsUrl, { headers: this.headers }).pipe(
			map((solutionAreaJson: any) => {
				solutionAreaJson = solutionAreaJson[0];
				const solutionAreaArray: reportOptionsInterface[] = [];
				for (const saJson of solutionAreaJson.solutionArea) {
					const solutionArea: reportOptionsInterface = {
						id: saJson.id,
						name: saJson.name,
					};
					solutionAreaArray.push(solutionArea);
				}
				return solutionAreaArray;
			})
		);
	}

	updateTask(requestData: requestInterface, task: tasksInterface, fields?: TaskCustomField[]) {
		const putTaskUrl = this.putTaskUrl.replace('{idRequest}', requestData.id);
		if (task.task_status === 'Pending') {
			task.task_status = 'In Progress';
		}
		const body = {
			idTask: task.id_task,
			idAnalystTask: task.task_analyst,
			task_id_solution_area: task.task_id_solution_area,
			idCustomer: requestData.id_customer,
			Status: task.task_status,
			notes: task.task_description,
			attachmentTask: task.attachment,
			predecessor: '',
			customTaskFields: fields ? fields : [],
		};

		console.log('[updateTask] Request ID:', requestData.id, '| Task ID:', task.id_task, '| Status:', task.task_status);
		console.log('[updateTask] customTaskFields:', fields);
		console.log('[updateTask] Body completo:', body);

		return this.http.put<JSON[]>(putTaskUrl, body, { headers: this.headers });
	}

	updateTaskApprover(idRequest: string, task: tasksInterface, fields?: TaskCustomField[]): Observable<any> {
		const putTaskApproverUrl = this.putTaskApproverUrl.replace('{idRequest}', idRequest);
		const body: any = {
			id: task.id_task,
			approver: [],
			connector: '',
		};

		for (const value of task.taskApproverFormItem[0].values) {
			if (value.unchangeable != true) body.approver.push(value.values[0]);
		}

		body.connector = task.taskApproverFormItem[1].values[0] ? task.taskApproverFormItem[1].values[0] : 'OR';

		// Only include customTaskFields if fields is defined and not empty
		if (fields && fields.length > 0) {
			body.customTaskFields = fields;
		}

		console.log('[updateTaskApprover] Request ID:', idRequest, '| Task ID:', task.id_task);
		console.log('[updateTaskApprover] customTaskFields:', fields);
		console.log('[updateTaskApprover] Body completo:', body);

		return this.http.put(putTaskApproverUrl, body, { headers: this.headers });
	}

	getChangePlan(idRequest: string): Observable<any> {
		const changePlanUrl = this.getChangePlanUrl.replace('{idRequest}', idRequest);
		return this.http.get(changePlanUrl, { headers: this.headers });
	}

	updateChangePlan(idRequest: string, changePlan: changePlanInterface): Observable<JSON[]> {
		const putChangePlanUrl = this.putChangePlanUrl.replace('{idRequest}', idRequest);
		const body = {
			riskUrgency: changePlan.urgency,
			riskImpact: changePlan.impact,
			riskCategory: changePlan.category,
			risk: changePlan.risk,
			riskAssessement: changePlan.riskAssessement,
			fallback: changePlan.fallback,
		};
		return this.http.put<JSON[]>(putChangePlanUrl, body, { headers: this.headers });
	}

	getCitypes(): Observable<ciTypesInterface[]> {
		return this.http.get<ciTypesInterface[]>(this.getCiTypesUrl, { headers: this.headers });
	}

	getSearchCis(ciParameter: ciInterface): Observable<ciInterface[]> {
		const queryString = `id=${ciParameter.ciArray[0].id}&type=${ciParameter.ciArray[0].type}&identification=${ciParameter.ciArray[0].identification}&solution_area=${ciParameter.ciArray[0].id_solution_area[0]}`;
		const searchCisUrl = this.searchCisUrl.replace('{queryString}', queryString);
		return this.http.get<JSON>(searchCisUrl, { headers: this.headers }).pipe(
			map((ciRes: any) => {
				const newCiArray: ciInterface[] = [];

				ciRes.forEach((ci: any) => {
					const newCi: ciInterface = {
						ciType: ci.type,
						ciArray: [
							{
								id: ci.id,
								cmdb_id: ci.id,
								status: ci.status,
								identification: ci.identification,
								type: ci.type,
								idCiType: ci.idCiType,
							},
						],
					};

					newCiArray.push(newCi);
				});

				return newCiArray;
			})
		);
	}

	addCiToRequest(idRequest: string, idCi: string): Observable<JSON> {
		const postInsertCiRequest = this.postInsertCiRequest.replace('{idRequest}', idRequest);
		const body = { requestID: idRequest, ciID: idCi };
		return this.http.post<JSON>(postInsertCiRequest, body, { headers: this.headers });
	}

	removeCiFromRequest(idRequest: string, idCi: string): Observable<JSON> {
		const deleteCiRequest = this.deleteCiRequest.replace('{idRequest}', idRequest).replace('{idCi}', idCi);
		return this.http.delete<JSON>(deleteCiRequest, { headers: this.headers });
	}

	duplyRequest(requestToCopy: requestInterface): Observable<JSON> {
		const body: any = { summary: requestToCopy.summary, description: requestToCopy.description };
		body.idEnduser = requestToCopy.id_enduser;
		if (requestToCopy.id_solution_area && requestToCopy.id_solution_area !== '' && requestToCopy.topic && requestToCopy.topic !== '') {
			body.idSolutionArea = requestToCopy.id_solution_area;
			body.idTopic = requestToCopy.id_topic;
		}

		return this.http.post<JSON>(this.cloneRequestUrl, body, { headers: this.headers });
	}

	getFile(fileName: string): Observable<mspFileInterface> {
		const getLogFile = this.getLogFile.replace('{fileName}', fileName);
		return this.http.get(getLogFile, { headers: this.headers }).pipe(
			map((fileRes: any) => {
				const newMspFile: mspFileInterface = {
					content: fileRes.content,
					name: fileRes.name,
					mimeType: fileRes.mimeType,
					extension: fileRes.extension,
					size: 0,
					file_path: '',
				};

				return newMspFile;
			})
		);
	}

	updateCountStrike(idRequest: string, countStrike: string): Observable<any> {
		const putCountStrikeUrl = this.putCountStrikeUrl.replace('{idRequest}', idRequest);
		const body = {
			count_strikes: countStrike,
		};

		return this.http.put<JSON>(putCountStrikeUrl, body, { headers: this.headers });
	}

	getCheckSlaTask(filters: any): Observable<subRequestInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<subRequestInterface[]>(this.getCheckSlaTaskUrl, { headers: headers, params: parameters });
	}

	createRequestFromTask(requestId: string, requestTaskId: string): Observable<CreateRequestResponse> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = { requestId: requestId, requestTaskId: requestTaskId };

		return this.http.post<CreateRequestResponse>(this.postRequestFromTask, body, { headers: headers });
	}

	replaceNewlinesAndBr(inputText: string): string {
		if (inputText) {
			let replacedText = inputText.replaceAll(String.raw`\n`, '\n');
			replacedText = replacedText.replaceAll('\n', '\n');

			return replacedText;
		}
		return inputText;
	}

	sendLogEmailEnduser(idLog: string, emailCC?: string) {
		const EmailEnduserUrl = this.postEmailSendUserUrl.replace('{idLog}', idLog);
		const body = emailCC ? { emailCC: emailCC } : { emailCC: '' };

		return this.http.post<JSON>(EmailEnduserUrl, body, { headers: this.headers });
	}

	getEmailStatus(requestID: string): Observable<emailStatusInterface[]> {
		const checkEmailStatusURL = `${this.checkEmailStatusURL}?requestID=${requestID}`;
		return this.http.get<emailStatusInterface[]>(checkEmailStatusURL, { headers: this.headers });
	}

	getSearchKbSolution(words: string): Observable<any> {
		const searchKbSolutionURL = `${this.searchKbSolutionURL}?words=${words}`;
		return this.http.get<any>(searchKbSolutionURL, { headers: this.headers });
	}

	closeChildRequest(idRequest: string): Observable<any> {
		const closeChildRequestsUrl = this.closeChildRequestsUrl.replace('{idRequest}', idRequest);
		return this.http.put<any>(closeChildRequestsUrl, {}, { headers: this.headers });
	}

	postCustomTask(task: any): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.http.post<any>(this.postCustomTasksUrl, task, { headers: headers });
	}

	deleteCustomTask(task: tasksInterface): Observable<any> {
		if (!task) return of({});

		const deleteCustomTaskUrl = this.deleteCustomTaskUrl.replace('{idTask}', task.id_task);
		return this.http.delete<any>(deleteCustomTaskUrl, { headers: this.headers });
	}

	getCrisisTeamForm(idRequest: string): Observable<genericFormInterface[]> {
		const getCrisisTeamFormUrl = this.getCrisisTeamFormUrl.replace('{idRequest}', idRequest);
		return this.http.get<genericFormInterface[]>(getCrisisTeamFormUrl, { headers: this.headers });
	}

	updateCrisisTeam(idRequest: string, newUsers: string[]): Observable<any> {
		const crisisTeamUrl = this.crisisTeamUrl.replace('{idRequest}', idRequest);
		return this.http.put<any>(crisisTeamUrl, newUsers, { headers: this.headers });
	}

	getConfidentialUsers(idRequest: string): Observable<string[]> {
		const getConfidentialUsersUrl = this.getConfidentialUsersUrl.replace('{idRequest}', idRequest);
		return this.http.get<any>(getConfidentialUsersUrl, { headers: this.headers });
	}

	resendTaskApprovalEmail(requestID: string, idTask: string): Observable<any> {
		const url = `${environment.baseApiUrl}tool/resendEmail?requestID=${requestID}&emailType=emailTaskApproval&idTask=${idTask}`;
		return this.http.get<any>(url, { headers: this.headers });
	}

	// Método para formatar os dados no formato correto
	private formatToBackendFormat(date: string, time: string): string {
		if (!date || !time) return ''; // Evita valores indefinidos ou nulos
		return `${date} ${time}:00`; // Formato esperado: "YYYY-MM-DD HH:MM:00"
	}

	// Método para enviar os dados no formato correto
	updateChangePlanDates(idRequest: string, changePlanDates: any): Observable<any> {
		const putUpdateChangePlanDatesUrl = this.putUpdateChangePlanDates.replace('{idRequest}', idRequest);
		const body = {
			start_date: this.formatToBackendFormat(changePlanDates.startDateAgreed, changePlanDates.startTimeAgreed),
			limit_date: this.formatToBackendFormat(changePlanDates.endDateAgreed, changePlanDates.endTimeAgreed),
			execution_start_date: this.formatToBackendFormat(changePlanDates.execStartDate, changePlanDates.execStartTime),
			execution_end_date: this.formatToBackendFormat(changePlanDates.execEndDate, changePlanDates.execEndTime),
			unavailability_start_date: this.formatToBackendFormat(
				changePlanDates.unavailabilityStartDate,
				changePlanDates.unavailabilityStartTime
			),
			unavailability_end_date: this.formatToBackendFormat(
				changePlanDates.unavailabilityEndDate,
				changePlanDates.unavailabilityEndTime
			),
		};

		return this.http.put<JSON>(putUpdateChangePlanDatesUrl, body, { headers: this.headers });
	}
}
